import { apiClient } from "../../../lib";

export const exportApi = {
    fetchExport: async ({ page, limit }: { page: number, limit: number }): Promise<any> => {
        const response = await apiClient.get(`/export`, { params: { page, limit } });
        return response.data;
    },
    downloadExport: async (exportObjectKey: string): Promise<any> => {
        const response = await apiClient.get(`/export/${exportObjectKey}/download`, { responseType: 'blob' });
        return response.data;
    },
    getStandardReport: async (): Promise<any> => {
        const response = await apiClient.get(`/report/columns-for-standard-report?reportType=PRE_CONFIGURED`);
        return response.data;
    },
    generateExport: async ({ reportKey, reportStartDate, reportEndDate }: { reportKey: string, reportStartDate: string, reportEndDate: string }): Promise<any> => {
        const response = await apiClient.post(`/report?reportName=${reportKey}&fromDate=${reportStartDate}&toDate=${reportEndDate}`);
        return response.data;
    }
};